/* Tab, Oct 11 2026 — product page design C: gallery (per-set photos, swipe, thumbs, lightbox) + phone sticky bar.
   Variant logic, Add to cart, cart drawer, sizing popup are the theme's own (product.js / modal-dialog.js). */
(function () {
  'use strict';
  function initSection(root) {
    if (!root || root.dataset.tpcReady) return;
    root.dataset.tpcReady = '1';
    var sectionId = root.dataset.section;
    var track = root.querySelector('.tpc-gtrack');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.tpc-gslide'));
    var thumbWrap = root.querySelector('.tpc-gthumbs');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.tpc-gth'));
    var countEl = root.querySelector('.tpc-gcount');
    var dotsEl = root.querySelector('.tpc-gdots');
    var prevBtn = root.querySelector('.tpc-gprev');
    var nextBtn = root.querySelector('.tpc-gnext');
    var shown = [];
    var shownThumbs = [];
    var current = 0;
    var variantData = null;
    try { var vs = root.querySelector('variant-selects script[type="application/json"]'); if (vs) variantData = JSON.parse(vs.textContent); } catch (e) {}

    function orderFor(list, key) {
      var own = [], common = [], rest = [];
      list.forEach(function (el) {
        if (key && el.dataset.group === key) own.push(el);
        else if (el.dataset.group === 'common') common.push(el);
        else rest.push(el);
      });
      if (!own.length && !common.length) return list.slice();
      if (!own.length && key) return list.slice(); // unknown group: show everything rather than nothing
      return own.concat(common);
    }
    function setGroup(mediaId, keepIndex) {
      var key = mediaId != null ? String(mediaId) : null;
      shown = orderFor(slides, key);
      var seen = new Set();
      shown = shown.filter(function (s) {
        var img = s.querySelector('img');
        if (!img || s.dataset.type !== 'image') return true;
        var src = img.getAttribute('src') || '';
        var file = src.split('/').pop().split('?')[0];
        var stem = /^([0-9]+)(?:_[a-z0-9-]+)?\.(jpg|jpeg|png|webp)$/i.exec(file);
        var id = stem ? stem[1] : file;
        if (seen.has(id)) return false;
        seen.add(id); return true;
      });
      // Tab, Oct 15 2026 — 5-7 photos per listing (Abraham, Oct 14 10:50 PM). A set with fewer than 4 photos of its own borrows the product's
      // shared photos (data-shared) from the first set; then every set is capped at data-gallery-max slides, the video kept as the last one.
      var gEl = root.querySelector('.tpc-gallery'); var galleryMax = parseInt(gEl && gEl.dataset.galleryMax, 10) || 7;
      var imgs = shown.filter(function (s) { return s.dataset.type === 'image'; });
      var vids = shown.filter(function (s) { return s.dataset.type !== 'image'; });
      if (imgs.length < 4 && key) {
        var firstKey = null;
        for (var fi = 0; fi < slides.length; fi++) { if (slides[fi].dataset.group !== 'common') { firstKey = slides[fi].dataset.group; break; } }
        var have = new Set(imgs.map(function (s) { var im = s.querySelector('img'); var f = ((im && im.getAttribute('src')) || '').split('/').pop().split('?')[0]; var st = /^([0-9]+)(?:_[a-z0-9-]+)?\.(jpg|jpeg|png|webp)$/i.exec(f); return st ? st[1] : f; }));
        slides.forEach(function (s) {
          if (s.dataset.type !== 'image' || s.dataset.shared !== '1' || s.dataset.group !== firstKey) return;
          var im = s.querySelector('img'); var f = ((im && im.getAttribute('src')) || '').split('/').pop().split('?')[0]; var st = /^([0-9]+)(?:_[a-z0-9-]+)?\.(jpg|jpeg|png|webp)$/i.exec(f); var id = st ? st[1] : f;
          if (have.has(id)) return; have.add(id); imgs.push(s);
        });
      }
      imgs = imgs.slice(0, Math.max(1, galleryMax - vids.length));
      shown = imgs.concat(vids);
      var shownIds = new Set(shown.map(function (s) { return s.dataset.media; }));
      var thumbById = {}; thumbs.forEach(function (t) { thumbById[t.dataset.media] = t; });
      shownThumbs = shown.map(function (s) { return thumbById[s.dataset.media]; }).filter(Boolean);
      slides.forEach(function (s) { s.classList.remove('is-shown'); });
      thumbs.forEach(function (t) { t.classList.remove('is-shown'); });
      shown.forEach(function (s) { s.classList.add('is-shown'); track.appendChild(s); });
      if (thumbWrap) shownThumbs.forEach(function (t) { t.classList.add('is-shown'); thumbWrap.appendChild(t); });
      pauseVideos();
      if (dotsEl) { dotsEl.innerHTML = ''; if (shown.length > 1) shown.forEach(function () { dotsEl.appendChild(document.createElement('i')); }); }
      current = keepIndex ? Math.min(current, shown.length - 1) : 0;
      track.scrollTo({ left: current * track.clientWidth, behavior: 'instant' in track ? 'instant' : 'auto' });
      paint();
    }
    function pauseVideos() { root.querySelectorAll('.tpc-gslide video').forEach(function (v) { try { v.pause(); } catch (e) {} }); }
    function paint() {
      if (countEl) countEl.textContent = (current + 1) + ' / ' + shown.length;
      if (dotsEl) Array.prototype.forEach.call(dotsEl.children, function (d, i) { d.classList.toggle('on', i === current); });
      shownThumbs.forEach(function (t, i) { t.classList.toggle('on', i === current); });
      if (prevBtn) prevBtn.disabled = current <= 0;
      if (nextBtn) nextBtn.disabled = current >= shown.length - 1;
      var on = shownThumbs[current]; if (on && thumbWrap && thumbWrap.clientHeight) { var r = on.getBoundingClientRect(), w = thumbWrap.getBoundingClientRect(); if (r.top < w.top || r.bottom > w.bottom) on.scrollIntoView({ block: 'nearest' }); }
    }
    function goTo(i) { if (!shown.length) return; current = Math.max(0, Math.min(i, shown.length - 1)); track.scrollTo({ left: current * track.clientWidth, behavior: 'smooth' }); paint(); }
    var scrollT;
    track.addEventListener('scroll', function () { clearTimeout(scrollT); scrollT = setTimeout(function () { var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); if (i !== current) { current = i; paint(); } }, 60); });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(shownThumbs.indexOf(t)); }); });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') goTo(current + 1); if (e.key === 'ArrowLeft') goTo(current - 1); });
    window.addEventListener('resize', function () { track.scrollTo({ left: current * track.clientWidth }); });

    // Lightbox (desktop click on the big photo)
    var lb = document.getElementById('tpc-lightbox');
    if (!lb) {
      lb = document.createElement('div'); lb.id = 'tpc-lightbox'; lb.className = 'tpc-lightbox'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-label', 'Photo');
      lb.innerHTML = '<button type="button" class="tpc-lightbox__close" aria-label="Close">×</button><img alt="">';
      document.body.appendChild(lb);
      lb.addEventListener('click', function () { lb.classList.remove('is-open'); document.body.classList.remove('overflow-hidden'); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { lb.classList.remove('is-open'); document.body.classList.remove('overflow-hidden'); } });
    }
    track.addEventListener('click', function (e) {
      var img = e.target.closest('.tpc-gslide img'); if (!img || window.innerWidth < 900) return;
      lb.querySelector('img').src = img.dataset.full || img.currentSrc || img.src; lb.classList.add('is-open'); document.body.classList.add('overflow-hidden');
    });

    // Variant → photos of that set
    document.addEventListener('product:variant-change', function (e) {
      if (!e.detail || e.detail.sectionId !== sectionId) return;
      var v = e.detail.variant;
      if (v && v.featured_media) setGroup(v.featured_media.id);
    });
    // A set picked whose size combination doesn't exist: still show that set's photos
    root.querySelectorAll('.tpc-opt--photos').forEach(function (fs) {
      fs.addEventListener('change', function () {
        var checked = fs.querySelector('input:checked'); if (!checked || !variantData) return;
        var idx = parseInt((fs.dataset.index || 'option1').replace('option', ''), 10) - 1;
        for (var i = 0; i < variantData.length; i++) { var vv = variantData[i]; if (vv.options && vv.options[idx] === checked.value && vv.featured_media) { setGroup(vv.featured_media.id); break; } }
      });
    });

    // Set swatch row on phones: arrow buttons + edge fades (Abraham, Oct 11 2:00 PM: users must see there are more sets)
    root.querySelectorAll('.tpc-vwrap').forEach(function (w) {
      var row = w.querySelector('.tpc-vthumbs'); if (!row) return;
      function paintV() { var max = row.scrollWidth - row.clientWidth; w.classList.toggle('no-scroll', max <= 4); w.classList.toggle('is-start', row.scrollLeft <= 4); w.classList.toggle('is-end', row.scrollLeft >= max - 4); }
      row.addEventListener('scroll', paintV, { passive: true }); window.addEventListener('resize', paintV); paintV(); setTimeout(paintV, 600);
      w.querySelectorAll('[data-tpc-scroll]').forEach(function (b) { b.addEventListener('click', function () { row.scrollBy({ left: parseInt(b.dataset.tpcScroll, 10) * Math.max(120, row.clientWidth * 0.7), behavior: 'smooth' }); }); });
      var on = row.querySelector('input:checked+label'); if (on) { var r = on.getBoundingClientRect(), rr = row.getBoundingClientRect(); if (r.right > rr.right || r.left < rr.left) on.scrollIntoView({ block: 'nearest', inline: 'center' }); }
    });

    // Desktop: the left column (photos + video) sticks as one block; when it is taller than the window it sticks by its bottom edge instead
    var left = root.querySelector('.tpc-left');
    function stickTop() { if (!left) return; if (window.innerWidth < 900) { left.style.removeProperty('--tpc-left-top'); return; } var hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 70; var top = hh + 16; var h = left.offsetHeight; if (h + top > window.innerHeight - 16) top = Math.min(top, window.innerHeight - h - 16); left.style.setProperty('--tpc-left-top', top + 'px'); }
    stickTop(); window.addEventListener('resize', stickTop); setTimeout(stickTop, 800); window.addEventListener('load', stickTop);


    // ---- Tab QA fix, Oct 11 2026: availability + Add to cart state ----
    // The theme's setDisabled() paints "is-disabled" on the radios by INDEX, assuming they appear in the same order as the variant list.
    // Our pickers are shown in display order (3-4 … 15-16, Set-1 … Set-15, colours A-Z), so that painting landed on the wrong buttons.
    // Here the classes are painted by VALUE after every change: a size is crossed out when that (colour, size) variant is missing or sold out;
    // a colour is dimmed only when every size of it is sold out.
    var vsel = root.querySelector('variant-selects');
    function fieldsets() { return vsel ? Array.prototype.slice.call(vsel.querySelectorAll('fieldset')) : []; }
    function selectedValues() { return fieldsets().map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; }); }
    function matchVariant(opts) {
      if (!variantData) return null;
      for (var i = 0; i < variantData.length; i++) { var v = variantData[i], ok = true; for (var j = 0; j < opts.length; j++) { if (opts[j] != null && v.options[j] !== opts[j]) { ok = false; break; } } if (ok) return v; }
      return null;
    }
    function paintAvailability() {
      if (!vsel || !variantData) return;
      var sel = selectedValues();
      fieldsets().forEach(function (fs, i) {
        fs.querySelectorAll('input').forEach(function (inp) {
          var exists = false, avail = false, k, v;
          if (i === 0) { for (k = 0; k < variantData.length; k++) { v = variantData[k]; if (v.options[0] === inp.value) { exists = true; if (v.available) { avail = true; break; } } } }
          else { var opts = sel.slice(); opts[i] = inp.value; v = matchVariant(opts); exists = !!v; avail = !!(v && v.available); }
          inp.classList.toggle('is-disabled', !avail);
          inp.classList.toggle('is-missing', !exists);
          inp.setAttribute('aria-disabled', avail ? 'false' : 'true');
        });
      });
    }
    // Picking a colour/set whose current size does not exist or is sold out: move to the first available size of that colour (in the displayed order),
    // so the button is enabled whenever something is buyable and says "Sold out" only when that colour is sold out in every size.
    // Runs in the capture phase, i.e. before the theme's own change handler reads the radios.
    root.querySelectorAll('.tpc-opt--photos').forEach(function (fs) {
      fs.addEventListener('change', function () {
        if (!variantData) return;
        var all = fieldsets(), sel = selectedValues(), v = matchVariant(sel);
        if (v && v.available) return;
        var others = all.filter(function (f) { return f !== fs; }); if (!others.length) return;
        var of = others[0], oi = all.indexOf(of), inputs = of.querySelectorAll('input');
        for (var n = 0; n < inputs.length; n++) { var o = sel.slice(); o[oi] = inputs[n].value; var vv = matchVariant(o); if (vv && vv.available) { inputs[n].checked = true; return; } }
        // nothing in stock for this colour: keep an existing combination so the theme shows "Sold out" (not "Unavailable")
        if (!v) { for (n = 0; n < inputs.length; n++) { o = sel.slice(); o[oi] = inputs[n].value; if (matchVariant(o)) { inputs[n].checked = true; return; } } }
      }, true);
    });
    // Instant button state from the variant JSON (the theme re-fetches the whole section before it re-enables the button, which takes 1-3 s on a phone)
    document.addEventListener('product:variant-change', function (e) {
      if (!e.detail || e.detail.sectionId !== sectionId) return;
      paintAvailability();
      var v = e.detail.variant, b = root.querySelector('.tpc-atc'), t = b && b.querySelector('.single-add-to-cart-button--text');
      if (v && b && t) { if (v.available) { b.removeAttribute('disabled'); b.classList.remove('sold-out'); t.textContent = (window.theme && theme.variantStrings && theme.variantStrings.addToCart) || 'Add to cart'; } else { b.setAttribute('disabled', 'disabled'); b.classList.add('sold-out'); t.textContent = (window.theme && theme.variantStrings && theme.variantStrings.soldOut) || 'Sold out'; } }
    });
    paintAvailability();
    setTimeout(paintAvailability, 300);


    // 13b (Oct 11 3:20 PM): the swatch box scrolls vertically now — bring the selected swatch into view on load
    root.querySelectorAll('.tpc-vthumbs').forEach(function (row) { var on = row.querySelector('input:checked+label'); if (on) { var r = on.getBoundingClientRect(), rr = row.getBoundingClientRect(); if (r.bottom > rr.bottom || r.top < rr.top) row.scrollTop = Math.max(0, on.offsetTop - row.offsetTop - 4); } });
    // Phone sticky bar: shows once the main Add to cart button has scrolled off the top
    var sticky = root.querySelector('.tpc-sticky');
    var atc = root.querySelector('.tpc-atc');
    var form = document.getElementById('product-form-' + sectionId);
    if (sticky && atc && form && 'IntersectionObserver' in window) {
      var sbtn = sticky.querySelector('[data-tpc-sticky-add]');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var passed = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-shown', passed); sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
        });
      }, { threshold: 0 });
      io.observe(atc);
      function mirror() { var t = atc.querySelector('.single-add-to-cart-button--text'); if (t && sbtn) { sbtn.textContent = t.textContent.trim(); sbtn.disabled = atc.disabled; } }
      new MutationObserver(mirror).observe(atc, { attributes: true, childList: true, subtree: true, characterData: true });
      mirror();
      if (sbtn) sbtn.addEventListener('click', function () {
        if (atc.disabled) { root.querySelector('.tpc-buybox').scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }

    setGroup(root.dataset.initialMedia || null);
  }
  function initAll() { document.querySelectorAll('.tpc[data-section]').forEach(initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector && e.target.querySelector('.tpc[data-section]'); if (r) { delete r.dataset.tpcReady; initSection(r); } });
})();


/* ---- Tab item 9 (Oct 12 2026): desktop quick-buy box beside the title, kept in sync with the main form ---- */
(function () {
  function initMini(root) {
    var mini = root.querySelector('.tpc-mini'); if (!mini) return;
    var sectionId = mini.dataset.section;
    var form = document.getElementById('product-form-' + sectionId);
    var atc = root.querySelector('.tpc-atc');
    var vsel = root.querySelector('variant-selects');
    var sel = mini.querySelector('[data-tpc-mini-size]');
    var btn = mini.querySelector('[data-tpc-mini-add]');
    var lbl = mini.querySelector('[data-tpc-mini-label]');
    var mainPrice = document.getElementById('price-' + sectionId);
    var miniPrice = document.getElementById('price-' + sectionId + '--mini');
    var variantData = null;
    try { var vs = root.querySelector('variant-selects script[type="application/json"]'); if (vs) variantData = JSON.parse(vs.textContent); } catch (e) {}
    // The size fieldset (falls back to the last option when no option is called size)
    var sizeFs = root.querySelector('.tpc-opt--size') || root.querySelector('fieldset.tpc-opt:last-of-type');
    function fsIndex(fs) { return parseInt((fs.dataset.index || 'option1').replace('option', ''), 10) - 1; }
    function selectedOptions() { var out = []; root.querySelectorAll('fieldset.tpc-opt').forEach(function (fs) { var c = fs.querySelector('input:checked'); out[fsIndex(fs)] = c ? c.value : null; }); return out; }
    function variantFor(opts) { if (!variantData) return null; for (var i = 0; i < variantData.length; i++) { var v = variantData[i], ok = true; for (var j = 0; j < opts.length; j++) { if (opts[j] != null && v.options[j] !== opts[j]) { ok = false; break; } } if (ok) return v; } return null; }
    function buildSelect() {
      if (!sel || !sizeFs) return;
      var idx = fsIndex(sizeFs), cur = selectedOptions();
      if (lbl) { var name = sizeFs.querySelector('.tpc-olabel'); if (name) lbl.textContent = (name.textContent.split(':')[0] || 'Size').trim(); }
      sel.innerHTML = '';
      sizeFs.querySelectorAll('input.tpc-radio').forEach(function (inp) {
        var o = cur.slice(); o[idx] = inp.value; var v = variantFor(o);
        var opt = document.createElement('option'); opt.value = inp.value;
        opt.textContent = inp.value + (v && v.available ? '' : ' — sold out');
        if (!v || !v.available) opt.disabled = true;
        if (inp.checked) opt.selected = true;
        sel.appendChild(opt);
      });
    }
    function mirrorButton() { if (!atc || !btn) return; var t = atc.querySelector('.single-add-to-cart-button--text'); btn.textContent = t ? t.textContent.trim() : 'Add to cart'; btn.disabled = !!atc.disabled; }
    function mirrorPrice() { if (mainPrice && miniPrice) miniPrice.innerHTML = mainPrice.innerHTML; }
    if (sel) sel.addEventListener('change', function () {
      var inp = sizeFs && sizeFs.querySelector('input.tpc-radio[value="' + sel.value.replace(/"/g, '\\"') + '"]');
      if (inp && !inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    if (btn) btn.addEventListener('click', function () {
      if (!form || (atc && atc.disabled)) return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
    if (vsel) vsel.addEventListener('change', function () { setTimeout(buildSelect, 0); });
    document.addEventListener('product:variant-change', function (e) { if (!e.detail || e.detail.sectionId !== sectionId) return; buildSelect(); mirrorButton(); });
    if (atc) new MutationObserver(mirrorButton).observe(atc, { attributes: true, childList: true, subtree: true, characterData: true });
    if (mainPrice) new MutationObserver(mirrorPrice).observe(mainPrice, { childList: true, subtree: true, characterData: true });
    buildSelect(); mirrorButton(); mirrorPrice();
  }
  function boot() { document.querySelectorAll('.tpc').forEach(initMini); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
